import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { CategoryList } from 'shared/types';

export function useCategories() {
    const { parameterService } = useService();

    const { data, isLoading, isFetching } = useQuery<CategoryList[], Error>(['categories'], () =>
        parameterService.getCategories()
    );

    return { categories: data, isLoading, isFetching } as const;
}
